// eslint-disable-next-line @typescript-eslint/no-var-requires
const M = require('../libs/materialize/bin/materialize.js');

export default function useMaterialize() {
  return M;
}
